import { render, staticRenderFns } from "./VariantUpsertCard.vue?vue&type=template&id=4919e5db&scoped=true&"
import script from "./VariantUpsertCard.vue?vue&type=script&lang=js&"
export * from "./VariantUpsertCard.vue?vue&type=script&lang=js&"
import style0 from "./VariantUpsertCard.vue?vue&type=style&index=0&id=4919e5db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4919e5db",
  null
  
)

export default component.exports